import { FC } from 'react'

import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Outlet } from 'react-router'

/**
 * Gate that requires an authenticated Auth0 user. Unauthenticated visitors are sent
 * through the Auth0 login flow before the wrapped routes render.
 */
const Protected: FC = () => {
  const WithAuthenticationRequired = withAuthenticationRequired(Outlet)
  return <WithAuthenticationRequired />
}

export default Protected
